export default __webpack_public_path__ + "static/media/correct_json_format.14c6d1b9.png";